import React,{useState, useEffect} from 'react'
import styles from './BottomGraphPanel.module.scss'
import HorizontalMultiBarChart from '../../components/HorizontalMultiBarChart'
import HorizontalBarChart from '../../components/HorizontalBarChart'
import toolTipFormatter from './toolTipFormatter'
import dataDisplayOptions from './dataDisplayOptions'
import stateOptions from '../../components/Map/usStatesAll'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import Modal from '../../components/ModalPopupProfile'
import Icon from '../../components/Icon'
import { CSVLink } from 'react-csv'
import Empty_Vaccine_Rate from '../../assets/images/Empty_Vaccine_Rate.png';
const BottomGraphPanel = ({ getfilterts }) => {  

  const [getData, setData] = useState('')

  var fluseasonValue = getfilterts.season
  const [showUnsubscribeDialog, setShowUnsubscribeDialog] = useState(false)
  const { showAddsubscribePop, setShowAddsubscribePop } = useGeoState()
  const { vulCount } = useGeoState()
  const onUnsubscribeClick = () => {
    
    setShowUnsubscribeDialog(true)
  }

  const onUnsubscribeCancelClick = () => {
    setShowUnsubscribeDialog(false)  
  }
  
  const { data, error } = useGeoFetch('', '', 'FluVaccine', 
     `VaccinationRate`,

    {
      lob : getfilterts.lob,
      type : getfilterts.type,
      fluseason : getfilterts.season,
      month : getfilterts.month,
      fluFolder : 'VaccinationRate'
    },
    'POST'
    )
  //const { data, error } = useGeoFetch('', '', 'FluVaccine', 'VaccinationRate',  getfilterts, 'VaccinationRate',getfilterts.season, getfilterts.month, getfilterts.lob , getfilterts.type)
  useEffect(() => {
    debugger
    if (data !== undefined && data !== null) {
     // if (data.response_code === 200) 
       // {     
      console.log(`data is ${data}`)  
      setData(data)
      //} 
      // else {
      //   setErrorCode(filterData.response_code)
      //   setErrorMessage(filterData.response_message)
      //   setErrorSubject(filterData.response_subject)
      //   seterrorOccured(true)
      // }
      
    }     
  }, [data])

  return   (
    <div className={styles.base}>
      {(fluseasonValue === '11' || fluseasonValue === '12') ?
      <>
        <div className={styles.ratePanel}>
          <span>
            State Vaccination Rate
            <span>
            Patients Count: <strong>{vulCount}</strong>


             
          </span>
          </span>         
          <HorizontalMultiBarChart
            toolTipFormatter={toolTipFormatter}
            entity="FluVaccine"
            location="VaccinationRate"
            options={stateOptions}
            dataDisplayOptions={dataDisplayOptions}
            filterId={getfilterts}
            fluFolder='VaccinationRate'
            fluseason={getfilterts.season}
            month={getfilterts.month}
            lob={getfilterts.lob}
            type={getfilterts.type}
            show=''
          />

          <span className={styles.graphSource}>
            Source : <span>Medical and Pharmacy Claims Data</span>
            <span style={{marginLeft:'185px', fontSize:'12px', cursor:'pointer'}} ><a onClick={onUnsubscribeClick}>Load More States</a></span>
          </span>
        
        </div>

          <div>
            <Modal
              open={showUnsubscribeDialog}
              onClose={() => setShowUnsubscribeDialog(false)}
              margin='60px'
              setWidth='80vw'
              setHeight='0vw'
              display=''
            >
              <button
                noValidate
                style={{ marginLeft: '100%' }}
                onClick={onUnsubscribeCancelClick}
              >
                <Icon type="remove" size={'1.0rem'} />
              </button>
              <div className={styles.modal} style={{overflowY:'scroll', height:'500px'}}>               
              <HorizontalMultiBarChart
                toolTipFormatter={toolTipFormatter}
                entity="FluVaccine"
                location="VaccinationRate"
                options={stateOptions}
                dataDisplayOptions={dataDisplayOptions}
                filterId={getfilterts}
                fluFolder='VaccinationRate'
                fluseason={getfilterts.season}
                month={getfilterts.month}
                lob={getfilterts.lob}
                type={getfilterts.type}
                show="all"
          />
                
                </div>
            </Modal>

          </div>
</>
 :
 <div className={styles.ratePanel}>
 <span>
   State Vaccination Rate
 </span>
 <div>
   <div style={{textAlign:'center'}}>
   
   <img  src={Empty_Vaccine_Rate}  />
   </div>
   <span style={{fontSize: "15px"}} >
   Please select either 2023-2024 or 2024-2025 to view State wise Vaccination Rates
   </span>
 </div>

</div> 
       
       
      }
      {/* <div className={styles.healthPanel}>
        <span>
          Top Health Care Plans
          <span>
            Patients Count <strong>6.5M</strong>
          </span>
        </span>
        <HorizontalBarChart
          toolTipFormatter={toolTipFormatter}
          entity="FluVaccine"
          location="PopularProduct"
          options={stateOptions}
          dataDisplayOptions={dataDisplayOptions}
          chartName="chart1"
          //filterid="PopularProduct-LOB-All_VTYPE-All_FLUSEASON-10_MONTH-All"
          height='400'
          filterId={getfilterts}
          fluFolder='PopularProduct'
          fluseason={getfilterts.season}
          month={getfilterts.month}
          lob={getfilterts.lob}
          type={getfilterts.type}
        />
        <span className={styles.graphSource}>
          Source : <span>Medical and Pharmacy Claims Data</span>
        </span>
      </div> */}

 {fluseasonValue !== '11' &&  fluseasonValue !== '12' ?

      <div>      
        <div className={styles.rateList}>
        <span>
          State Vaccination List
          <span>
            Patients Count <strong>{vulCount}</strong>
          </span>
        </span>
        <HorizontalBarChart
          toolTipFormatter={toolTipFormatter}
          entity="FluVaccine"
          location="StateWise"
          options={stateOptions}
          dataDisplayOptions={dataDisplayOptions}
          chartName="chart1"
          height='400'
          filterId={getfilterts}
          fluFolder='StateWise'
          fluseason={getfilterts.season}
          month={getfilterts.month}
          lob={getfilterts.lob}
          type={getfilterts.type}
        />
        <span className={styles.graphSource}>
          Source : <span>Medical and Pharmacy Claims Data</span>
        </span>
        </div>
      </div>
 : (
  null
)}
    <div className={styles.rateList}>

        <span>
          Top Health Care Plans
          <span>
            Patients Count: <strong>{vulCount}</strong>
          </span>
        </span>
        <HorizontalBarChart
          toolTipFormatter={toolTipFormatter}
          entity="FluVaccine"
          location="PopularProduct"
          options={stateOptions}
          dataDisplayOptions={dataDisplayOptions}
          chartName="chartPopularProd"
          //filterid="PopularProduct-LOB-All_VTYPE-All_FLUSEASON-10_MONTH-All"
          height='400'
          filterId={getfilterts}
          fluFolder='PopularProduct'
          fluseason={getfilterts.season}
          month={getfilterts.month}
          lob={getfilterts.lob}
          type={getfilterts.type}
        />
        <span className={styles.graphSource}>
          Source : <span>Medical and Pharmacy Claims Data</span>
        </span>
        </div>
 
    </div>
  )


  
  
}

export default BottomGraphPanel
